import { Injectable, computed, signal } from '@angular/core';
import { AUTH_CONFIG } from '../../core/auth/auth.config';

/**
 * Single source of truth for the signed-in user's application role.
 *
 * `currentRole` is set from `GET user/v1/me`'s `me_role` via `setCurrentRole()`,
 * called by whichever guard/service already fetches that response (see `onboardingGuard`).
 * `canAccessAdmin` is derived from it (role === `Admin`).
 */
@Injectable({ providedIn: 'root' })
export class RoleService {
  readonly currentRole = signal<string>(AUTH_CONFIG.roles.USER);
  readonly department = signal<string>('');

  /** Gates admin UI (view switcher, admin routes) — driven by `me_role` from `user/v1/me`. */
  readonly canAccessAdmin = computed(
    () => this.currentRole().toLowerCase() === AUTH_CONFIG.roles.ADMIN.toLowerCase(),
  );

  /** Falls back to `User` when the API sends a null/empty `me_role`. */
  setCurrentRole(role: string | null | undefined): void {
    this.currentRole.set(role || AUTH_CONFIG.roles.USER);
  }

  setDepartment(department: string): void {
    this.department.set(department || '');
  }
}
